import { render, staticRenderFns } from "./CollectionUserAccountInfo.vue?vue&type=template&id=46b71896&scoped=true"
import script from "./CollectionUserAccountInfo.vue?vue&type=script&lang=js"
export * from "./CollectionUserAccountInfo.vue?vue&type=script&lang=js"
import style0 from "./CollectionUserAccountInfo.vue?vue&type=style&index=0&id=46b71896&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b71896",
  null
  
)

export default component.exports